var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { background: "rgb(25 36 68)" }, attrs: { id: "zhxq" } },
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c("div", { staticClass: "header" }, [
              _c("div", { staticClass: "left-time" }, [
                _vm._v(_vm._s(this.todayDate))
              ]),
              _c(
                "div",
                { staticClass: "right-menu" },
                [
                  _c("div", { staticClass: "user" }),
                  _c("div", { staticClass: "admin" }, [
                    _vm._v(_vm._s(this.userName))
                  ]),
                  !_vm.creenClose
                    ? _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: "全屏",
                            placement: "top",
                            effect: "light"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "Close",
                              staticStyle: { cursor: "pointer" },
                              on: { click: _vm.getFullCreeen }
                            },
                            [
                              _c("svg-icon", {
                                staticStyle: {
                                  color: "#68b9ff",
                                  "font-size": "1.2vw",
                                  "margin-top": "0.5vh"
                                },
                                attrs: { "icon-class": "fangda" }
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "0.6vw",
                                    color: "#7AB9FF",
                                    "margin-right": "8px",
                                    position: "relative",
                                    bottom: "2px"
                                  }
                                },
                                [_vm._v("全屏")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.creenClose
                    ? _c(
                        "el-tooltip",
                        {
                          attrs: {
                            content: "缩小",
                            placement: "top",
                            effect: "light"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "Close",
                              staticStyle: { cursor: "pointer" },
                              on: { click: _vm.getFullCreeen }
                            },
                            [
                              _c("svg-icon", {
                                staticStyle: {
                                  color: "#68b9ff",
                                  "font-size": "1.2vw"
                                },
                                attrs: { "icon-class": "suoxiao2" }
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "font-size": "0.6vw",
                                    color: "#7AB9FF",
                                    "margin-right": "8px",
                                    position: "relative",
                                    bottom: "2px"
                                  }
                                },
                                [_vm._v("缩小")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: "进入后台",
                        placement: "top",
                        effect: "light"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            cursor: "pointer",
                            "margin-right": "1vh",
                            margin: "-0.5vh 0 0 0vw"
                          },
                          on: { click: _vm.manage }
                        },
                        [
                          _c("svg-icon", {
                            staticStyle: {
                              "font-size": "1.2vw",
                              "margin-top": "1.9vh"
                            },
                            attrs: { "icon-class": "index" }
                          }),
                          _c(
                            "span",
                            { staticStyle: { "font-size": "0.6vw" } },
                            [_vm._v("进入后台")]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: "退出系统",
                        placement: "top",
                        effect: "light"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            cursor: "pointer",
                            "margin-right": "1vh",
                            margin: "-0.5vh 1vw 0 0.5vw"
                          },
                          on: { click: _vm.logout }
                        },
                        [
                          _c("svg-icon", {
                            staticStyle: {
                              "font-size": "1.2vw",
                              "margin-top": "1.9vh"
                            },
                            attrs: { "icon-class": "tuichu" }
                          }),
                          _c(
                            "span",
                            { staticStyle: { "font-size": "0.6vw" } },
                            [_vm._v("退出系统")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _c("div", { staticClass: "headTitle" }, [
                _vm._v(_vm._s(_vm.areaName))
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "div",
        [
          _c("Overview-Scenic", {
            ref: "overview",
            attrs: { "show-device-type": _vm.showDeviceType }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }